import EnterpriseReportSummary from "../../EnterpriseReportSummary";
import { buildPastReportDownloadInsights } from "../subscriptionInsights";

const PastReportDownloadSummary = ({ subscription, dateRange = [], reportTypes = [] }) => {
  const summary = buildPastReportDownloadInsights(subscription, dateRange, reportTypes);

  if (!summary) return null;

  return (
    <EnterpriseReportSummary
      title="Historical Export Preview"
      kpis={summary.kpis}
      tables={summary.tables}
      notes={summary.notes}
    />
  );
};

export default PastReportDownloadSummary;
